export default __webpack_public_path__ + "static/logo-69309640d571982461a7baaf6a9c41c3.png";